import React from 'react';
import { SignIn } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';

const signInAppearance = {
  variables: {
    colorPrimary: '#e9a020',
    colorBackground: '#0d2040',
    colorText: '#e2e8f0',
    colorTextSecondary: '#94a3b8',
    colorInputBackground: 'rgba(255,255,255,0.07)',
    colorInputText: '#e2e8f0',
    colorNeutral: '#64748b',
    borderRadius: '10px',
    fontFamily: 'inherit',
  },
  elements: {
    card: { background: 'transparent', boxShadow: 'none', padding: 0 },
    rootBox: { width: '100%' },
    headerTitle: { color: '#e2e8f0', display: 'none' },
    headerSubtitle: { display: 'none' },
    socialButtonsBlockButton: {
      background: 'rgba(0,119,181,0.12)',
      border: '1px solid rgba(0,119,181,0.35)',
      color: '#e2e8f0',
    },
    socialButtonsBlockButtonText: { color: '#e2e8f0', fontWeight: 500 },
    dividerLine: { background: 'rgba(255,255,255,0.08)' },
    dividerText: { color: '#64748b' },
    formFieldLabel: { color: '#94a3b8' },
    formFieldInput: { background: 'rgba(255,255,255,0.07)', borderColor: 'rgba(255,255,255,0.12)', color: '#e2e8f0' },
    footerActionLink: { color: '#e9a020' },
    footer: { background: 'transparent' },
    identityPreviewText: { color: '#e2e8f0' },
    identityPreviewEditButtonIcon: { color: '#e9a020' },
  },
};

export default function SignInPage() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: 'calc(100vh - 58px)',
      background: 'radial-gradient(ellipse at 20% 50%, rgba(233,160,32,0.06) 0%, transparent 60%), #0a1628',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 16px',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Background grid decoration */}
      <div style={{
        position: 'absolute', inset: 0, pointerEvents: 'none',
        backgroundImage: 'linear-gradient(rgba(233,160,32,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(233,160,32,0.03) 1px, transparent 1px)',
        backgroundSize: '48px 48px',
      }} />

      <div style={{ position: 'relative', width: '100%', maxWidth: 420 }}>
        {/* Card */}
        <div style={{
          background: 'rgba(13,32,64,0.85)',
          backdropFilter: 'blur(16px)',
          border: '1px solid rgba(233,160,32,0.15)',
          borderRadius: 18,
          padding: 'clamp(28px,5vw,40px)',
          boxShadow: '0 24px 64px rgba(0,0,0,0.45)',
        }}>
          {/* Logo */}
          <div style={{ textAlign: 'center', marginBottom: 28 }}>
            <button
              onClick={() => navigate('/')}
              style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'inline-block' }}
            >
              <span style={{
                fontFamily: "var(--font-display, 'Fraunces', serif)",
                fontSize: 26, fontWeight: 700, letterSpacing: '-0.5px', color: '#fff',
              }}>
                Fathom<span style={{ color: '#e9a020' }}>Voyage</span>
              </span>
            </button>
            <p style={{
              color: '#64748b', fontSize: 13, marginTop: 6,
              fontFamily: "var(--font-body, 'Figtree', sans-serif)",
            }}>
              Voyage Cost Intelligence
            </p>
          </div>

          {/* Clerk SignIn — LinkedIn only via Clerk dashboard config */}
          <SignIn
            appearance={signInAppearance}
            afterSignInUrl="/bunker"
            afterSignUpUrl="/bunker"
            routing="path"
            path="/sign-in"
          />

          {/* Professional context text */}
          <p style={{
            marginTop: 20,
            padding: '12px 16px',
            background: 'rgba(233,160,32,0.06)',
            border: '1px solid rgba(233,160,32,0.12)',
            borderRadius: 8,
            color: '#94a3b8',
            fontSize: 12.5,
            lineHeight: 1.6,
            textAlign: 'center',
            fontFamily: "var(--font-body, 'Figtree', sans-serif)",
          }}>
            FathomVoyage is built for maritime professionals.{' '}
            <strong style={{ color: '#cbd5e1', fontWeight: 500 }}>
              Sign in with LinkedIn to save your preferences.
            </strong>
          </p>
        </div>

        {/* Back to Pulse link */}
        <p style={{ textAlign: 'center', marginTop: 20 }}>
          <button
            onClick={() => navigate('/pulse')}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: '#64748b', fontSize: 13,
              fontFamily: "var(--font-body, 'Figtree', sans-serif)",
              textDecoration: 'underline', textUnderlineOffset: 3,
            }}
          >
            Continue reading Maritime Pulse without signing in
          </button>
        </p>
      </div>
    </div>
  );
}
